import resolve from 'ioc/resolve'
import webcolors from 'webcolors/webcolors'
import webfonts from 'webfonts/webfonts'
import confirm from 'webmodals/confirm'
import utils from 'emun.on-demand/lib/util'
import config from 'emun.on-demand/_fabric.config'

class DesignLayer {
    constructor(l, i, canvas, isObject) {
        let layer = this;
        let id = (angular.isString(l) ? l : angular.isObject(l) ? l.layerId || l.id : '') || '';
        layer.canvas = canvas;
        Object.assign(layer, utils.splatName(id));
        layer.index = i;
        layer.objects = isObject ? [l] : [];
        layer.fill = utils.observableFactory('Fill', 'Tint', 'BgColor');
        layer.text = utils.observableFactory('Text');
        layer.label = utils.simpleObservableFactory('label');
        layer.fontFamily = utils.observableFactory('FontFamily');
        layer.fontSize = utils.observableFactory('FontSize');
        layer.src = utils.observableFactory('Src');
        layer.width = utils.observableFactory('Width');
        layer.height = utils.observableFactory('Height');
        layer.scale = utils.observableFactory('ScaleX', 'ScaleY');
        layer.scaleX = utils.observableFactory('ScaleX');
        layer.scaleY = utils.observableFactory('ScaleY');
        layer.skewX = utils.observableFactory('SkewX');
        layer.skewY = utils.observableFactory('SkewY');
        layer.size = layer.scaleP = (v) => (v ? layer.scale(v / 100) : layer.scale()) * 100;
        layer.stroke = utils.observableFactory('Stroke');
        layer.opacity = utils.observableFactory('Opacity');
        layer.opacityP = (v) => (v ? layer.opacity(v / 100) : layer.opacity()) * 100;
        layer.left = utils.observableFactory('Left');
        layer.top = utils.observableFactory('Top');
        layer.shadow = utils.observableFactory('Shadow');
        layer.angle = utils.observableFactory('Angle');
        layer.strokeWidth = utils.observableFactory('StrokeWidth');
        layer.trapezoidDirection = utils.filterObservableFactory('Trapezoid', 'direction');
        layer.trapezoidFactor = utils.filterObservableFactory('Trapezoid', 'factor');
    }


    static build(canvas, design) {
        const zoom = canvas.getZoom();
        let layers = {
            loaded: new Date(),
            background: null,
            all: [],
            map: {},
            groups: [],
            clipart: [],
            pastDesigns: [],
            colors: [],
            text: [],
            shapes: [],
            icons: [],
            images: [],
            top: []
        };
        let map = layers.map;
        let index = 0;
        //canvas.backgroundColor = null;

        function process(o, parent, group) {
            //console.log('dbg.process', o, parent, group);
            if (o.layerId) {
                let layer = map[o.layerId];
                if (!layer) {
                    layer = map[o.layerId] = new DesignLayer(o, index++, canvas);
                    layer.group = group || canvas;
                    layer.parent = parent;
                    layer.level = parent ? (parent.level + 1) : 0;
                    o.fill = webcolors.format(o.fill);
                    o.stroke = webcolors.format(o.stroke);
                    if (layer.isText) {
                        layers.text.push(layer);
                        o.perPixelTargetFind = false;
                        o.selectable = true;
                    }
                    else if (layer.isColor || layer.isShape) {
                        o.hoverCursor = 'pointer';
                        layers.colors.push(layer);
                        if (layer.isBackground) {
                            canvas.backgroundColor = o.fill;
                            layers.background = layer;
                        }
                        else if (layer.isShape) layers.shapes.push(layer);
                    }
                    else if (layer.isImage) layers.images.push(layer);
                    else if (layer.isIcon) layers.icons.push(layer);
                    else if (layer.isGroup) {
                        if (!group) {
                            layers.groups.push(layer);
                            layers.clipart.push(layer);
                            if (layer.isClipart = o.sourcePath.indexOf('/designs/') > 0) layers.clipart.push(layer);
                            if (layer.isPastDesign = o.sourcePath.indexOf('/renderings/') > 0) layers.pastDesigns.push(layer);
                        }

                        o.getObjects().forEach(oo => process(oo, layer, o));
                        //o.setCoords();
                    };

                    if (layer.isTop) o.bringToFront();
                    layers.all.push(layer);
                }

                layer.objects.push(o);
                if (!layer.label()) layer.label(layer.name);
                if (!layer.isMovable && !group && !design.anythingGoes) {
                    utils.iDontMove(o, layer); // TODO: verify
                }
                if (design.perspective && !(o.lockMovementX || o.lockMovementY) && layer.level === 0 && !o.groupId) {
                    let rect = o.getBoundingRect();
                    for (let p in rect) rect[p] /= zoom;
                    rect.left -= design.perspective.x;
                    rect.top -= design.perspective.y;
                    if (layer.isText || layer.isImage) {
                        o.isOutOfBounds = utils.isOutOfBounds(rect, design);
                        layer.isOutOfBounds = (!!layer.isOutOfBounds) || o.isOutOfBounds;
                    }
                }
            }
            if (design.anythingGoes) {
                o.set({
                    selectable: true,
                    hasControls: true,
                    hasBorders: true,
                    hoverCursor: 'pointer',
                    moveCursor: 'default',
                    hasBorders: true,
                    lockMovementX: false,
                    lockMovementY: false,
                    lockScalingX: false,
                    lockScalingY: false,
                    lockUniScaling: false,
                    lockRotation: false
                });
            }
        }

        canvas.getObjects().forEach(oo => process(oo));
        //for (let layerId in layers.map) {
        //  let l = layers.map[layerId];
        //  if (l.objects.filter(lo => !lo.group).length > 1) {
        //    console.log('dbg.Group', layerId, l);
        //    let clones = l.objects.filter(lo => !!lo).map(lo => lo.clone()).filter(lo => !!lo);
        //    console.log('dbg.clones', clones);
        //    let group = new fabric.Group(clones);
        //    console.log('dbg.group', group);
        //    canvas.add(group);
        //    console.debug('dbg.Group', group);
        //    l.objects.forEach(lo => console.log('removed', lo, canvas.remove(lo)));
        //  }
        //}
        layers.all.reverse();
        layers.images.reverse();
        layers.clipart.reverse();
        layers.pastDesigns.reverse();
        layers.colors.reverse();
        layers.text.reverse();
        layers.groups.reverse();
        layers.shapes.reverse();
        resolve('$rootScope').$emit('designLayersProcessed', { layers, canvas });

        return layers;
    }

    isDark() {
        return webcolors.isDark(this.fill());
    }

    remove() {
        let layer = this;
        let deferred = resolve('$q').defer();
        confirm(`Do you really want to remove ${layer.lineage()}?`, 'Confirm').result.then(() => {
            angular.forEach(layer.objects, o => {
                //o && o.remove && o.remove();
                layer.group && layer.group.remove(o);
                layer.canvas && layer.canvas.remove(o);
            });
            //layer.designer.render();
            deferred.resolve();
        }, deferred.reject);
        return deferred.promise;
    }

    topLayer() {
        let layer = this;
        while (layer.parent && layer.canvas != layer.parent) {
            layer = layer.parent;
        }
        return layer;
    }

    lineage() {
        let layer = this;
        let result = layer.label();
        while (layer.parent && layer.canvas != layer.parent) {
            layer = layer.parent;
            result = layer.label() + ' \u203A ' + result;
        }
        return result;
    }

    select(top) {
        let layer = top ? this.topLayer() : this;
        angular.forEach(layer.objects, o => {
            layer.canvas.setActiveObject(o);
        });
    }

    imageLoading() {
        let layer = this;
        return !!layer.get('loading');
    }

    imageUrl() {
        return this.objects[0].sourcePath.replace('design.json', this.isClipart ? 'thumbnail.png' : 'flat/thumbnail.jpg');
    }

    icon() {
        let sl = this;
        return sl.isText ? 'font' : sl.isDesign ? 'ban' : sl.isClipart ? 'paint-brush' : sl.isPastDesign ? 'history' : sl.isImage ? 'picture-o' : 'eyedropper';
    }

    complexity() {
        return this.objects.reduce((a, o) => a += (o.complexity ? o.complexity() : 1), 0);
    }

    get(prop) {
        let layer = this;
        return layer && layer.objects && layer.objects.map(o => o.get(prop)).filter(o => o !== null && o !== undefined)[0];
    }

    set(prop, value) {
        this.objects.forEach(o => o.set(prop, value));
    }

    contain(bounds, maxZoom) {
        let layer = this;
        layer.objects.forEach(o => {
            let scale = utils.getContainScale(o, bounds, maxZoom);
            o.set({
                scaleX: scale,
                scaleY: scale,
                left: bounds.width / 2,
                top: bounds.height / 2,
                originX: 'center',
                originY: 'center'
            });
            o.setCoords();
        });
        resolve('$rootScope').$emit('designerObjectModified', { layer });
    }

    cover(bounds, maxZoom) {
        let layer = this;
        layer.objects.forEach(o => {
            let scale = utils.getCoverScale(o, bounds, maxZoom);
            o.set({
                scaleX: scale,
                scaleY: scale,
                left: bounds.width / 2,
                top: bounds.height / 2,
                originX: 'center',
                originY: 'center'
            });
            o.setCoords();
        });
        resolve('$rootScope').$emit('designerObjectModified', { layer });
    }

    center(bounds) {
        let layer = this;
        this.centerV(bounds);
        this.centerH(bounds);
    }

    centerV(bounds) {
        let layer = this;
        layer.objects.forEach(o => {
            o.set({
                top: bounds.height / 2,
                offsetY: 'center',
                originY: 'center'
            });
            o.setCoords();
        });
        resolve('$rootScope').$emit('designerObjectModified', { layer });
    }

    centerH(bounds) {
        let layer = this;
        layer.objects.forEach(o => {
            o.set({
                textAlign: 'center',
                left: bounds.width / 2,
                offsetX: 'center',
                originX: 'center'
            });
            o.setCoords();
        });
        //layer.objects.forEach(o => o.centerH().setCoords());
        resolve('$rootScope').$emit('designerObjectModified', { layer });
    }

    scaleRelative(amt) {
        let layer = this;
        if (!amt) amt = 1;
        layer.objects.forEach(o => {
            o.set({
                scaleX: o.scaleX * amt,
                scaleY: o.scaleY * amt,
            });
            o.setCoords();
        });
        resolve('$rootScope').$emit('designerObjectModified', { layer });
    }

    opacityRelative(amt) {
        let layer = this;
        if (!amt) amt = o;
        layer.objects.forEach(o => {
            o.set({
                opacity: Math.min(1, Math.max(0, o.opacity + amt)),
            });
            o.setCoords();
        });
        resolve('$rootScope').$emit('designerObjectModified', { layer });
    }

    rotateRelative(amt) {
        let layer = this;
        if (!amt) amt = 90;
        layer.objects.forEach(o => {
            console.log('rr', amt, o.angle, o.angle % Math.abs(amt), o.angle - (o.angle % Math.abs(amt)));
            o.set({
                angle: (360 + o.angle - (o.angle % Math.abs(amt)) + amt) % 360
            });
            o.setCoords();
        });
        resolve('$rootScope').$emit('designerObjectModified', { layer });
    }

    bringForward(top) {
        let layer = top ? this.topLayer() : this;
        layer.objects.forEach(o => o.bringForward());
        resolve('$rootScope').$emit('designerObjectModified', { layer });
    }

    bringToFront(top) {
        let layer = top ? this.topLayer() : this;
        layer.objects.forEach(o => o.bringToFront());
        resolve('$rootScope').$emit('designerObjectModified', { layer });
    }

    sendBackwards(top) {
        let layer = top ? this.topLayer() : this;
        layer.objects.forEach(o => o.sendBackwards());
        resolve('$rootScope').$emit('designerObjectModified', { layer });
    }

    sendToBack(top) {
        let layer = top ? this.topLayer() : this;
        layer.objects.forEach(o => o.sendToBack());
        resolve('$rootScope').$emit('designerObjectModified', { layer });
    }
}

export default DesignLayer